import React from 'react';
import { prevent } from '../../../../common/utils';
export function useSelected(state, props) {
    var getDisplayIndex = state.getDisplayIndex, getOptions = state.getOptions, emitChange = state.emitChange, closePanel = state.closePanel, isReadonly = state.isReadonly, isDisabled = state.isDisabled;
    var submitOnEnter = props.submitOnEnter;
    var _a = React.useState(null), selectedIndex = _a[0], setSelectedIndex = _a[1];
    function onkey(event) {
        if (event.key === Keys.Enter) {
            prevent(event);
            var displayIndex = getDisplayIndex();
            if (!select(displayIndex, event)) {
                if (submitOnEnter) {
                    selectFirst(event);
                }
            }
        }
    }
    function select(index, event) {
        if (isReadonly() || isDisabled())
            return;
        state.clearFilter();
        state.setDisplayIndex(index);
        setSelectedIndex(index);
        var value = getOptions()[index];
        if (value) {
            emitChange(value, event);
            closePanel();
            return true;
        }
        else {
            emitChange(null, event);
        }
    }
    function selectFirst(event) {
        if (isReadonly() || isDisabled())
            return;
        var items = getOptions();
        if (items.length === 1) {
            emitChange(items[0], event);
            closePanel();
        }
    }
    return {
        select: select,
        index: selectedIndex,
        onKeyUp: onkey,
    };
}
